import { TOAST_TYPE } from '@/constants/toasts'
import { newKRData } from '@/goalUtils'
import { filterIdForCreationId, nowInterval, setDefaultIntervalId } from '@/interval'
import service from '@/service'
import urlManager from '@/urlManager'
import showToast from '@/utils/showToast'
import * as R from 'ramda'
import { mapActions } from 'vuex'

/**
 * This contain common handlers required for goal creation flow
 */
export default {
  data() {
    return {
      orgCheckinFrequency: null,
      isSubmitting: false,
      errorMessages: {}
    }
  },
  methods: {
    ...mapActions(['createNewGoal']),
    async fetchCheckinFrequency() {
      const response = await service.client.get(urlManager.notificationSettings(this.orgId))
      this.orgCheckinFrequency = response.data.checkinFrequency
      return this.orgCheckinFrequency
    },
    async setParentGoals(parentGoals, goalId) {
      try {
        await service.client.post(urlManager.goalDetail({ orgId: this.orgId, goalId }), {
          action: 'set_parent_goals',
          goalIds: parentGoals.map(goal => goal.id)
        })
      } catch (e) {
        const message = R.path(['response', 'data', 'message'], e)
        showToast(message || 'Error while linking to parent goals', TOAST_TYPE.ERROR)
      }
    },
    newGoalData(teamId, userId) {
      return {
        teamId: teamId,
        title: '',
        description: '',
        ownerId: userId,
        coOwnerIds: [],
        keyResults: R.range(0, 2).map(() => newKRData(userId)),
        checkinFrequency: '',
        timeline: nowInterval().id,
        parentId: null
      }
    },
    prepareGoalFromTemplate(goalTemplate, teamId, userId) {
      const keyResults =
        goalTemplate.keyResults?.map(kr => ({
          ...newKRData(userId),
          ...kr
        })) || []
      return {
        ...this.newGoalData(teamId, userId),
        ...R.pick(['title', 'description'], goalTemplate),
        keyResults
      }
    },
    async createGoal({ parentGoals, goal } = {}) {
      try {
        this.isSubmitting = true
        const createdGoal = await this.createNewGoal({
          orgId: this.orgId,
          teamId: goal.teamId,
          title: goal.title,
          description: goal.description,
          ownerId: goal.ownerId,
          coOwnerIds: goal.coOwnerIds,
          timeline: goal.timeline,
          checkinFrequency: goal.checkinFrequency || 'weekly',
          keyResults: goal.keyResults
        })
        setDefaultIntervalId(filterIdForCreationId(goal.timeline))
        if (parentGoals) {
          await this.setParentGoals(parentGoals, createdGoal.id)
        }
        this.isSubmitting = false
        return createdGoal
      } catch (e) {
        console.warn('Caught error while creating goal', e)
        const response = R.pathOr({}, ['response', 'data'], e)
        if (response.detail instanceof Array) {
          this.errorMessages = { errors: response.detail }
        } else if (response.detail && !R.isEmpty(response.detail)) {
          this.errorMessages = response.detail
        } else {
          this.errorMessages = { errors: [response.message] }
        }
      }
      this.isSubmitting = false
    }
  }
}
